import { Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

const AddButton = ({ onAddClick, isMobile }) => (
  <Button
    variant="contained"
    startIcon={<AddIcon sx={{ fontSize: { xs: 18, sm: 22 } }} />}
    onClick={onAddClick}
    className="poppins-font"
    sx={{
      borderRadius: 5,
      px: { xs: 1, sm: 2 },
      py: { xs: 0.5, sm: 0.8 },
      fontWeight: 500,
      fontSize: { xs: "0.75em", sm: "0.90em" }, // smaller font
      minWidth: { xs: 60, sm: 90 },
      boxShadow: 2,
      background: "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
      color: "#fff",
      "&:hover": {
        background: "linear-gradient(135deg, #1e40af 0%, #2563eb 100%)",
      },
    }}
  >
    {isMobile ? "ADD" : "ADD NEW"}
  </Button>
);

export default AddButton;
